import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Select, Checkbox, CurrencyInput } from 'src/common';
import { CURRENCIES } from 'src/helpers/constants';
import styles from './index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDash } from '@fortawesome/pro-light-svg-icons';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
interface Props {
  disabled?: boolean;
  min?: number;
  max?: number;
}
const ContractValueFilter: FC<Props> = ({ disabled, min, max }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.inputContainer}>
        <div className={styles.maxMin}>
          <CurrencyInput
            name={'min'}
            placeholder={t('ExpiringContracts.min')}
            className={styles.input}
            disabled={disabled}
            value={min}
          />
          <div>
            <FontAwesomeIcon icon={faDash} className={styles.icon} />
          </div>
          <CurrencyInput
            name={'max'}
            placeholder={t('ExpiringContracts.max')}
            className={styles.input}
            disabled={disabled}
            value={max}
          />
        </div>

        <Form.Item name={'currency'} className={styles.currencySelect}>
          <Select
            showSearch
            optionFilterProp={'value'}
            getPopupContainer={trigger => trigger.parentNode}
            className={styles.select}
            listHeight={125}
            filterOption={(input, option) =>
              !!option && !!option.value && option.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder={t('ExpiringContracts.currency')}
            allowClear
            disabled={disabled}
            suffixIcon={<FontAwesomeIcon className={styles.selectIcon} icon={faCaretDown} />}
          >
            {CURRENCIES.map(c => (
              <Select.Option key={c.code} value={c.code}>
                <span className={styles.currencySymbol}>{c.symbol_native}</span>
                <span className={styles.currencyCode}>{c.code}</span>
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>
      <Form.Item name={'includeMissingValue'} valuePropName={'checked'} className={styles.missingValueCheckbox}>
        <Checkbox disabled={disabled}>{t('ExpiringContracts.includeMissingValue')}</Checkbox>
      </Form.Item>
    </>
  );
};

export default ContractValueFilter;
